import api, { setApiAuthToken } from './api'

/** Entry-gateway environment (Main operational data or Demo — Sales Showcase). Null when no gateway is present. */
export type AppEnvironment = 'main' | 'demo'
export type EnvironmentState = { environment: AppEnvironment; available: AppEnvironment[] }

export async function getEnvironment(): Promise<EnvironmentState | null> {
  try {
    const response = await fetch('/__nx/environment', { credentials: 'same-origin', cache: 'no-store' })
    if (!response.ok) return null
    const body = await response.json()
    return body?.success ? { environment: body.environment, available: body.available } : null
  } catch { return null }
}

/** Switching environment ends sessions in both environments and clears local auth context before reloading. */
export async function setEnvironment(environment: AppEnvironment) {
  const response = await fetch('/__nx/environment', { method: 'POST', credentials: 'same-origin', cache: 'no-store',
    headers: { 'content-type': 'application/json', 'x-nx-environment-switch': '1' }, body: JSON.stringify({ environment }) })
  if (!response.ok) throw new Error('environment_switch_failed')
  setApiAuthToken(null)
  try { sessionStorage.clear() } catch { /* storage may be unavailable */ }
  window.location.assign('/login')
}

export type PersonaAccount = { userId: string; email: string; label: string; roleKey: string; workerType?: string; accessState?: string; tenantId?: string; current: boolean; presenter: boolean }
export type PersonaDirectory = { profile: string; presenterUserId: string; currentUserId: string; actingAsPresenter: boolean;
  groups: Array<{ organization: string; organizationCode?: string; roles: Array<{ role: string; accounts: PersonaAccount[] }> }> }

export async function getPersonaDirectory(): Promise<PersonaDirectory | null> {
  try { const response = await api.get('/api/demo-showcase/personas'); return response.data?.success ? response.data : null }
  catch { return null }
}

/** Opens a new, audited session for the selected demo identity and reloads so no stale context survives. */
export async function switchPersona(userId: string, presenterCode?: string) {
  const response = await api.post('/api/demo-showcase/personas/switch', { userId, ...(presenterCode ? { presenterCode } : {}) })
  setApiAuthToken(response.data.token)
  try { sessionStorage.clear() } catch { /* storage may be unavailable */ }
  window.location.assign('/admin')
}

export async function revokePersonaSessions() {
  const response = await api.post('/api/demo-showcase/personas/revoke', {})
  return response.data?.revoked as number
}
